import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Translation resources
const resources = {
  en: {
    translation: {
      // App
      appName: "GPSBox Portal",
      appDescription: "Manage your GPSBox device and parking locations",

      // Authentication
      signIn: "Sign In",
      signUp: "Sign Up",
      signOut: "Sign Out",
      logout: "Log Out",

      // Navigation
      dashboard: "Dashboard",
      deviceLink: "Link Device",
      deviceStatus: "Device Status",
      locationHistory: "Location History",
      parkingHistory: "Parking History",
      parkingLocations: "Parking Locations",
      userSettings: "Settings",

      // Theme
      light: "Light",
      dark: "Dark",
      system: "System",

      // Languages
      english: "English",
      polish: "Polish",

      // General
      loading: "Loading...",
      settings: "Settings",
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      add: "Add",
      date: "Date",
      time: "Time",
      duration: "Duration",
      status: "Status",
      location: "Location",
      cost: "Cost",
      address: "Address",
      distance: "Distance",
      speed: "Speed",

      // Parking History
      parkingHistoryDescription: "Review your parking sessions and costs",
      parkingSessions: "Parking Sessions",
      parkingLocation: "Parking Location",
      startTime: "Start Time",
      endTime: "End Time",
      totalCost: "Total Cost",
      paymentMethod: "Payment Method",
      sessionDuration: "Session Duration",
      noParkingHistory: "No parking sessions found",

      // Parking Status
      parkingActive: "Active",
      parkingStopped: "Stopped",
      parkingPending: "Pending",

      // Location History
      locationHistoryDescription:
        "View your car's location history and trip data",
      locationTimeline: "Location Timeline",
      tripHistory: "Trip History",
      currentLocation: "Current Location",
      lastUpdated: "Last Updated",
      tripStarted: "Trip Started",
      tripEnded: "Trip Ended",
      averageSpeed: "Average Speed",
      maxSpeed: "Max Speed",
      noLocationHistory: "No location history found",
      noTrips: "No trips found",

      // Trip Status
      tripActive: "Active",
      tripCompleted: "Completed",
      tripPaused: "Paused",

      // Time formats
      timeAgo: "{{time}} ago",
      minutes: "minutes",
      hours: "hours",
      days: "days",

      // Units
      currency: "$",
      kilometers: "km",
      meters: "m",
      kmh: "km/h",
    },
  },
  pl: {
    translation: {
      // App
      appName: "GPSBox Portal",
      appDescription:
        "Zarządzaj swoim urządzeniem GPSBox i lokalizacjami parkingowymi",

      // Authentication
      signIn: "Zaloguj się",
      signUp: "Zarejestruj się",
      signOut: "Wyloguj się",
      logout: "Wyloguj się",

      // Navigation
      dashboard: "Panel główny",
      deviceLink: "Połącz urządzenie",
      deviceStatus: "Status urządzenia",
      locationHistory: "Historia lokalizacji",
      parkingHistory: "Historia parkowania",
      parkingLocations: "Lokalizacje parkowania",
      userSettings: "Ustawienia",

      // Theme
      light: "Jasny",
      dark: "Ciemny",
      system: "Systemowy",

      // Languages
      english: "Angielski",
      polish: "Polski",

      // General
      loading: "Ładowanie...",
      settings: "Ustawienia",
      save: "Zapisz",
      cancel: "Anuluj",
      edit: "Edytuj",
      delete: "Usuń",
      add: "Dodaj",
      date: "Data",
      time: "Czas",
      duration: "Czas trwania",
      status: "Status",
      location: "Lokalizacja",
      cost: "Koszt",
      address: "Adres",
      distance: "Dystans",
      speed: "Prędkość",

      // Parking History
      parkingHistoryDescription: "Przejrzyj swoje sesje parkowania i koszty",
      parkingSessions: "Sesje parkowania",
      parkingLocation: "Miejsce parkowania",
      startTime: "Czas rozpoczęcia",
      endTime: "Czas zakończenia",
      totalCost: "Całkowity koszt",
      paymentMethod: "Metoda płatności",
      sessionDuration: "Czas trwania sesji",
      noParkingHistory: "Nie znaleziono sesji parkowania",

      // Parking Status
      parkingActive: "Aktywne",
      parkingStopped: "Zatrzymane",
      parkingPending: "Oczekujące",

      // Location History
      locationHistoryDescription:
        "Zobacz historię lokalizacji swojego samochodu i dane podróży",
      locationTimeline: "Linia czasu lokalizacji",
      tripHistory: "Historia podróży",
      currentLocation: "Obecna lokalizacja",
      lastUpdated: "Ostatnia aktualizacja",
      tripStarted: "Podróż rozpoczęta",
      tripEnded: "Podróż zakończona",
      averageSpeed: "Średnia prędkość",
      maxSpeed: "Maks. prędkość",
      noLocationHistory: "Nie znaleziono historii lokalizacji",
      noTrips: "Nie znaleziono podróży",

      // Trip Status
      tripActive: "Aktywna",
      tripCompleted: "Zakończona",
      tripPaused: "Wstrzymana",

      // Time formats
      timeAgo: "{{time}} temu",
      minutes: "minut",
      hours: "godzin",
      days: "dni",

      // Units
      currency: "zł",
      kilometers: "km",
      meters: "m",
      kmh: "km/h",
    },
  },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
